import CorporationSelector from './CorporationSelector.vue'

export default CorporationSelector